module.exports = __webpack_public_path__ + "static/media/2025-Sports-Masterclass-Desktop-Banner@2x.e30355b9.jpg";